export default "__VITE_ASSET__DvZuxLOA__"